module.exports = __webpack_public_path__ + "img/info-healthcare.daab278b.svg";